import { render } from "./FormActionButton.vue?vue&type=template&id=60deade9"
import script from "./FormActionButton.vue?vue&type=script&lang=js"
export * from "./FormActionButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__